import { render, staticRenderFns } from "./ActionCenterUndoBar.vue?vue&type=template&id=9a5f0a00&scoped=true"
import script from "./ActionCenterUndoBar.vue?vue&type=script&lang=js"
export * from "./ActionCenterUndoBar.vue?vue&type=script&lang=js"
import style0 from "./ActionCenterUndoBar.vue?vue&type=style&index=0&id=9a5f0a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5f0a00",
  null
  
)

export default component.exports